import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map, take } from 'rxjs/operators';

import { environment } from '../../../core/core.module';
@Injectable()
export class RichTextService implements OnDestroy {
  private resources: Map<string, string> = new Map<string, string>();
  constructor(private readonly http: HttpClient) {}
  ngOnDestroy(): void {
    this.resources.forEach((srcUrl, imgUrl) => URL.revokeObjectURL(imgUrl));
  }
  transformToRichText(html: string): Observable<string> {
    if (html) {
      const document = new DOMParser().parseFromString(html, 'text/html');
      const elements = document.querySelectorAll('img');
      const observables: Observable<void>[] = [];
      elements.forEach((element) => {
        if (element.hasAttribute('src')) {
          const srcUrl = element.getAttribute('data-src');
          if (this.resources.has(srcUrl)) {
            observables.push(of(element.setAttribute('src', this.resources.get(srcUrl))));
          } else if (srcUrl) {
            observables.push(
              this.http
                .get(srcUrl, {
                  headers: {
                    Authorization: `Bearer ${environment.BEARER_TOKEN}`
                  },
                  observe: 'response',
                  responseType: 'blob'
                })
                .pipe(
                  map((response) => {
                    const imgUrl = URL.createObjectURL(response.body);
                    this.resources.set(srcUrl, imgUrl);
                    element.setAttribute('src', imgUrl);
                    element.setAttribute('data-src', srcUrl);
                  })
                )
            );
          } else {
            observables.push(
              this.http
                .get(element.getAttribute('src'), {
                  headers: {
                    Authorization: `Bearer ${environment.BEARER_TOKEN}`
                  },
                  observe: 'response',
                  responseType: 'blob'
                })
                .pipe(
                  map((response) => {
                    const imgUrl = URL.createObjectURL(response.body);
                    this.resources.set(srcUrl, imgUrl);
                    element.setAttribute('data-src', element.getAttribute('src'));
                    element.setAttribute('src', imgUrl);
                  })
                )
            );
            return;
          }
        }
      });
      if (observables.length > 0) {
        return forkJoin(observables)
          .pipe(take(1))
          .pipe(map(() => document.body.innerHTML));
      }
    }
    return of(html);
  }

  // replacing img src back to the correct upload src
  transformToParsedRichText(html: string): string {
    if (html) {
      const document = new DOMParser().parseFromString(html, 'text/html');
      document.querySelectorAll('img').forEach((element) => {
        if (element.hasAttribute('src')) {
          const srcUrl = element.getAttribute('data-src');
          element.setAttribute('src', srcUrl);
          element.removeAttribute('data-src');
        }
      });
      return document.body.innerHTML;
    }
    return '';
  }
}
